__webpack_require__.p = "https://assets.coolblue.nl/_app/careers-website-microfrontend/_next/";